module.exports = __webpack_public_path__ + "media/images/icons/SVG/061-c4d471f3575699f4b54fcd1a301a6348.svg";